import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
              primary: '#ffffff', // #E53935
              secondary: '#ffffff', // #FFCDD2
                // primary: '#404040', // #E53935
                // secondary: '#404040', // #FFCDD2
                accent: '#000000', // #3F51B5
            },
        },
        dark: false
    },
})
